import React from 'react';
import { weekDayName, monthName } from 'utils/date';

export default function ActivityHeader(props) {
  const today = new Date();

  return (
    <section className="activity-header">
      <h3>Today</h3>
      <div className="day-info">
        <p>
          <label>{weekDayName(today)}</label>
          <span>{`${monthName(
            today
          )} ${today.getDate()}, ${today.getFullYear()}`}</span>
        </p>
        <p>
          <label>{props.numberOfSessions}</label>
          <span>Sessions</span>
        </p>
      </div>
    </section>
  );
}
